import { IMatchupList } from '@/store/modules/game/interfaces';
import { IDraft } from './interfaces';

export default {
  SET_DRAFTS: (state: IDraftState, drafts: IDraft[]) => {
    state.drafts = drafts
  },
  CLEAR_DRAFTS: (state: IDraftState) => {
    state.drafts = []
  },
};
